"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var d3 = _interopRequireWildcard(require("d3"));
var _useChartDimensions = require("../hooks/useChartDimensions");
var _SvgChart = _interopRequireDefault(require("../components/SvgChart"));
var _useChartTooltip = require("../hooks/useChartTooltip");
var _useChartData = require("../hooks/useChartData");
var _d3Sankey = require("d3-sankey");
var _SankeyDiagram = require("./SankeyDiagram.styled");
var _useFilter = require("../hooks/useFilter");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// @ts-ignore

const BASE_MARGIN = Object.freeze({
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
});
const SankeyDiagram = /*#__PURE__*/(0, _react.memo)(chartProps => {
  var _chart$colors;
  const {
    chart,
    chartColors
  } = chartProps;
  const {
    yCol,
    yFormat,
    tooltipCol,
    componentProps,
    labelSize,
    seriesCol,
    xCol
  } = chart;
  const {
    align = "justify",
    sorted = true,
    linkColor = "neutral"
  } = componentProps;
  const palette = ((_chart$colors = chart.colors) === null || _chart$colors === void 0 ? void 0 : _chart$colors.schemes.categorical) || chartColors.schemes.categorical;
  const svgRef = _react.default.useRef(null);
  const boxRef = _react.default.useRef(null);
  const {
    filter,
    filterComponent
  } = (0, _useFilter.useFilter)(chartProps);
  let {
    width,
    height,
    margin
  } = (0, _useChartDimensions.useChartDimensions)(svgRef, BASE_MARGIN, chart.spanRow);
  const {
    data,
    xKeys,
    seriesKeys,
    seriesLabels,
    xLabels
  } = (0, _useChartData.useChartData)(chart, filter);
  const {
    tooltipRef,
    showTooltip,
    hideTooltip
  } = (0, _useChartTooltip.useChartTooltip)(chart, data, "yCol");
  const graphNodes = seriesKeys.concat(xKeys).map(key => ({
    key
  }));
  const graphLinks = data.map(d => d.points.map(p => {
    return {
      source: d.seriesKey,
      target: p[xCol],
      value: Number(p[yCol]),
      tooltip: p[tooltipCol]
    };
  })).flat();
  const alignments = {
    left: _d3Sankey.sankeyLeft,
    right: _d3Sankey.sankeyRight,
    center: _d3Sankey.sankeyCenter,
    justify: _d3Sankey.sankeyJustify
  };
  const sankey = (0, _d3Sankey.sankey)().nodeId(d => d.key).nodeAlign(alignments[align]).nodeWidth(15).nodePadding(4).nodeSort(sorted ? null : undefined).extent([[0, 5], [width, height - 5]]);
  const colorPalette = d3.scaleOrdinal().domain(graphNodes.map(node => node.key)).range(palette);
  let {
    nodes,
    links
  } = sankey({
    nodes: graphNodes,
    links: graphLinks
  });
  nodes = nodes.filter(node => node.sourceLinks.length > 0 || node.targetLinks.length > 0);
  const series = seriesLabels.concat(xLabels);
  return /*#__PURE__*/_react.default.createElement(_SvgChart.default, {
    margin: margin,
    svgRef: svgRef,
    boxRef: boxRef,
    tooltipRef: tooltipRef,
    chart: chart,
    palette: palette,
    seriesLabels: series,
    filterComponent: filterComponent
    //onVisible={handleVisible}
  }, /*#__PURE__*/_react.default.createElement("g", null, nodes.map(node => {
    var _chart$dataView$colum, _chart$dataView$colum2;
    return /*#__PURE__*/_react.default.createElement("rect", {
      x: node.x0 + 1,
      y: node.y0,
      height: node.y1 - node.y0,
      width: node.x1 - node.x0 - 2,
      fill: colorPalette(node.key),
      key: node.index,
      onMouseEnter: e => showTooltip(e.target, "top"),
      onMouseLeave: () => hideTooltip(),
      "data-label": "".concat(((_chart$dataView$colum = chart.dataView.columns[seriesCol].categories[node.key]) === null || _chart$dataView$colum === void 0 ? void 0 : _chart$dataView$colum.label) || ((_chart$dataView$colum2 = chart.dataView.columns[xCol].categories[node.key]) === null || _chart$dataView$colum2 === void 0 ? void 0 : _chart$dataView$colum2.label)),
      "data-value": node.value,
      "data-format": yFormat,
      "data-color": colorPalette(node.key)
    }, /*#__PURE__*/_react.default.createElement("title", null, "".concat(node.key, "\n").concat(node.value.toLocaleString())));
  })), /*#__PURE__*/_react.default.createElement(_SankeyDiagram.SankeyDiagramGroup, {
    className: "sankey-diagram"
  }, links.map(link => {
    var _chart$dataView$colum3, _chart$dataView$colum4, _chart$dataView$colum5, _chart$dataView$colum6;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, linkColor === "gradient" && /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: "gradient-".concat(link.index),
      gradientUnits: "userSpaceOnUse",
      x1: link.source.x1,
      x2: link.target.x0
    }, /*#__PURE__*/_react.default.createElement("stop", {
      offset: "0%",
      stopColor: colorPalette(link.source.key)
    }), /*#__PURE__*/_react.default.createElement("stop", {
      offset: "100%",
      stopColor: colorPalette(link.target.key)
    })), /*#__PURE__*/_react.default.createElement("path", {
      d: (0, _d3Sankey.sankeyLinkHorizontal)()(link),
      strokeWidth: Math.max(link.width, 1),
      stroke: linkColor === "gradient" ? "url(#gradient-".concat(link.index, ")") : linkColor === "source" ? colorPalette(link.source.key) : linkColor === "target" ? colorPalette(link.target.key) : "",
      key: link.index,
      className: "link",
      onMouseEnter: e => showTooltip(e.target, "top"),
      onMouseLeave: () => hideTooltip(),
      "data-label": "".concat(((_chart$dataView$colum3 = chart.dataView.columns[seriesCol].categories[link.source.key]) === null || _chart$dataView$colum3 === void 0 ? void 0 : _chart$dataView$colum3.label) || ((_chart$dataView$colum4 = chart.dataView.columns[xCol].categories[link.source.key]) === null || _chart$dataView$colum4 === void 0 ? void 0 : _chart$dataView$colum4.label), " -> ").concat(((_chart$dataView$colum5 = chart.dataView.columns[seriesCol].categories[link.target.key]) === null || _chart$dataView$colum5 === void 0 ? void 0 : _chart$dataView$colum5.label) || ((_chart$dataView$colum6 = chart.dataView.columns[xCol].categories[link.target.key]) === null || _chart$dataView$colum6 === void 0 ? void 0 : _chart$dataView$colum6.label)),
      "data-value": link.tooltip,
      "data-color": "linear-gradient(to right, ".concat(colorPalette(link.source.key), ", ").concat(colorPalette(link.target.key), ")")
    }));
  })), /*#__PURE__*/_react.default.createElement(_SankeyDiagram.SankeyDiagramTextGroup, {
    fontSize: labelSize === "small" ? "0.5rem" : "0.65rem"
  }, nodes.map(node => {
    var _chart$dataView$colum7, _chart$dataView$colum8, _chart$dataView$colum9;
    return /*#__PURE__*/_react.default.createElement("text", {
      x: node.x0 < width / 2 ? node.x1 + 6 : node.x0 - 6,
      y: (node.y1 + node.y0) / 2,
      dy: "0.35em",
      textAnchor: node.x0 < width / 2 ? "start" : "end",
      key: node.index,
      onMouseEnter: e => showTooltip(e.target, "top"),
      onMouseLeave: () => hideTooltip(),
      "data-label": "".concat(((_chart$dataView$colum7 = chart.dataView.columns[seriesCol].categories[node.key]) === null || _chart$dataView$colum7 === void 0 ? void 0 : _chart$dataView$colum7.label) || ((_chart$dataView$colum8 = chart.dataView.columns[xCol].categories[node.key]) === null || _chart$dataView$colum8 === void 0 ? void 0 : _chart$dataView$colum8.label)),
      "data-value": node.value,
      "data-color": colorPalette(node.key)
    }, ((_chart$dataView$colum9 = chart.dataView.columns[seriesCol].categories[node.key]) === null || _chart$dataView$colum9 === void 0 ? void 0 : _chart$dataView$colum9.label) || chart.dataView.columns[xCol].categories[node.key].label);
  })));
});
var _default = SankeyDiagram;
exports.default = _default;